import ErrorMessage from './ErrorMessage';
import LockIcon from '@mui/icons-material/Lock';
import useT from '@hooks/useT';

function UnauthorizedError() {
  const { t } = useT();
  return (
    <ErrorMessage
      title={t('errors:auth.unauthorizedTitle')}
      message={t('errors:auth.unauthorizedMessage')}
      icon={<LockIcon />}
      severity="error"
    />
  );
}

export default UnauthorizedError;

